import React, { Component, Fragment } from "react";
import {
  Input,
  Pagination,
  Dropdown,
  Menu,
  Select,
  Collapse,
  Table,
  Modal,
  Spin,
  Tabs,
} from "antd";
import Api from "../../ServiceApi";
import { CaretDownOutlined,CaretUpOutlined } from '@ant-design/icons';
import Cookies from "js-cookie";

const { Panel } = Collapse;
const { Option } = Select;

class WareHouse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      visible: false,
      title: "Warehouse",
      data: [],
      step: 0,
      category: [],
      filter: [],
      wh_index_selected: 0,
      wh_zone_index_selected: 0,
      wh_page: 1,
      sorter: "wh_zone_loc_code",
      sortasc: 1,
    };
  }

  async componentDidMount() {
    const team_list_api = await Api.post("materialstockP_GetAreaWhLevel", {
      TokenUser: "63423fe4c6ff56e7e9b4fcb0c50cb3f386316931",
      UserName: "tirapong_s",
      UserID: "",
      company_id: "1",
      operator_id: "",
      project_id: "",
      pk_id: "",
      fk_id: "",
      is_active: "",
      effective: "",
      sql_where: "",
    }).then((val) => {
      let result = this.toJson(val).area_warehouse_level;
      console.log(result);
      this.setState({
        data: result,
        filter: this.groupBy(result, "wh_id"),
      });
    });
  }
  toJson(jsonString) {
    let myJSONString = JSON.parse(JSON.stringify(jsonString.data.data));
    return JSON.parse(myJSONString);
  }

  groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };
  onFilter(step, wh_index, wh_zone) {
    this.setState({
      wh_index_selected: wh_index,
      wh_zone_index_selected: wh_zone,
      step: step,
    });
  }

  onSort = (e) => {
    let thisasc = this.state.sortasc;
    function compare(a, b) {
      if (a[e] < b[e]) {
        return thisasc === 1 ? -1 : 1;
      }
      if (a[e] > b[e]) {
        return thisasc === 1 ? 1 : -1;
      }
      return 0;
    }
    let sortedfilter = this.state.data.sort(compare);
    this.setState({
      data: sortedfilter,
      sorter: e,
    });
  };

  dataFiltered(wh_id, wh_zone_id) {
    let thisdata = this.state.data;
    let thisfilter = {
      wh_id: wh_id,
      wh_zone_id: wh_zone_id,
    };
    let thisstep = this.state.step;
    return this.state.data.filter(function (obj) {
      if (wh_id === 0) {
        return true;
      } else if (wh_zone_id === 0) {
        return obj.wh_id === wh_id ? true : false;
      } else {
        return obj.wh_id === wh_id && obj.wh_zone_id === wh_zone_id
          ? true
          : false;
      }
    });
  }
  sum(array, key) {
    return array.reduce((a, b) => a + (b[key] || 0), 0);
  }
  onModal(name, mode, visible) {
    if (visible == false) {
      this.formRef.current.resetFields();
    }
    if (name == "main") {
      this.setState({
        visible: visible,
        mode,
      });
    } else {
      this.setState({
        visible_sub: visible,
        mode,
      });
    }
  }

  render() {
    const { title, data, step, filter } = this.state;
    function arrObjhandler(a, b) {
      let res = !a ? {} : a[0];
      return res[b];
    }
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-3">
            <Input.Search
              placeholder="Search"
              onSearch={(value) => console.log(value)}
              /*style={{ width: }}*/
              className="mb-4"
            />
            <div className="menu-warehouse">
              <Collapse accordion defaultActiveKey={["1"]}>
                <Panel header="Area Warehouse" key="1">
                  {step === 0 ? (
                    <ul className="filter-warehouse">
                      <li className="title">
                        <span>All Area</span>
                        <span className="total">
                          {this.sum(data, "count_material")}
                        </span>
                      </li>
                      {Object.entries(filter).map((item, index) => (
                        <li key={index}>
                          <button
                            onClick={() =>
                              this.onFilter(1, item[1][0].wh_id, 0)
                            }
                          >
                            <span>{item[1][0].wh_code}</span>
                            <span className="total">
                              {this.sum(item[1], "count_material")}
                            </span>
                          </button>
                        </li>
                      ))}
                    </ul>
                  ) : null}
                  {step === 1 ? (
                    <ul className="filter-warehouse">
                      <li className="title">
                        <button onClick={() => this.onFilter(0, 0, 0)}>
                          <span>
                            <img
                              src={Api.absoluteUrl("/icon/arrow_left.png")}
                              alt=""
                              className="mr-2"
                            />
                            All Area
                          </span>
                          <span className="total">
                            {this.sum(data, "count_material")}
                          </span>
                        </button>
                      </li>
                      <li className="title">
                        <span>
                          {filter[this.state.wh_index_selected][0].wh_code}
                        </span>
                        <span className="total">
                          {this.sum(
                            filter[this.state.wh_index_selected],
                            "count_material"
                          )}
                        </span>
                      </li>
                      {Object.entries(
                        this.groupBy(
                          filter[this.state.wh_index_selected],
                          "wh_zone_id"
                        )
                      ).map((item, index) => {
                        return (
                          <li key={index}>
                            <button
                              onClick={() =>
                                this.onFilter(
                                  2,
                                  this.state.wh_index_selected,
                                  item[1][0].wh_zone_id
                                )
                              }
                            >
                              <span>{item[1][0].wh_zone_code}</span>
                              <span className="total">
                                {this.sum(item[1], "count_material")}
                              </span>
                            </button>
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}
                  {step === 2 ? (
                    <ul className="filter-warehouse">
                      <li className="title">
                        <button onClick={() => this.onFilter(0, 0, 0)}>
                          <span>
                            <img
                              src={Api.absoluteUrl("/icon/arrow_left.png")}
                              alt=""
                              className="mr-2"
                            />
                            All Area
                          </span>
                          <span className="total">
                            {this.sum(data, "count_material")}
                          </span>
                        </button>
                      </li>
                      <li className="title">
                        <button
                          onClick={() =>
                            this.onFilter(1, this.state.wh_index_selected, 0)
                          }
                        >
                          <span>
                            <img
                              src={Api.absoluteUrl("/icon/arrow_left.png")}
                              alt=""
                              className="mr-2"
                            />
                            {filter[this.state.wh_index_selected][0].wh_code}
                          </span>
                          <span className="total">
                            {this.sum(
                              filter[this.state.wh_index_selected],
                              "count_material"
                            )}
                          </span>
                        </button>
                      </li>
                      <li className="title">
                        <span>
                          {
                            this.groupBy(
                              filter[this.state.wh_index_selected],
                              "wh_zone_id"
                            )[this.state.wh_zone_index_selected][0].wh_zone_code
                          }
                        </span>
                        <span className="total">
                          {this.sum(
                            this.groupBy(
                              filter[this.state.wh_index_selected],
                              "wh_zone_id"
                            )[this.state.wh_index_selected],
                            "count_material"
                          )}
                        </span>
                      </li>
                      {/*filter.map((item, index)=><Fragment key={index}>
                                            
                                            {item.sub.map((subItem, subIndex)=><li key={subIndex} className="title">
                                                <span>{subItem.title}</span>
                                                <span className="total">{subItem.total}</span>
                                            </li>)}
                                        </Fragment>)*/}
                    </ul>
                  ) : null}
                </Panel>
              </Collapse>
            </div>
          </div>

          <div className="col-9">
            <div className="card-table-ma" style={{ padding: "25px 30px" }}>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <span className="font-mont-r fs-12">{title}</span>
                  {
                    {
                      0: (
                        <h3 className="font-mont-sb fs-18 c-blue mb-0">
                          All Area
                        </h3>
                      ),
                      1: (
                        <h3 className="font-mont-sb fs-18 c-blue mb-0">
                          {arrObjhandler(
                            filter[this.state.wh_index_selected],
                            "wh_code"
                          )}
                        </h3>
                      ),
                      2: (
                        <h3 className="font-mont-sb fs-18 c-blue mb-0">
                          {step === 0
                            ? null
                            : arrObjhandler(
                                this.groupBy(
                                  filter[this.state.wh_index_selected],
                                  "wh_zone_id"
                                )[this.state.wh_zone_index_selected],
                                "wh_zone_code"
                              )}
                        </h3>
                      ),
                    }[step]
                  }
                </div>

                <button
                  style={{ height: "36px" }}
                  className="btn btn-warning"
                  onClick={() => this.onModal("team", true)}
                >
                  <img src={Api.absoluteUrl("/icon/plus.svg")} className="mr-2" />
                  Add {title}
                </button>
              </div>

              <div className="d-flex justify-content-between align-items-center mb-4">
                <span>
                  <span className="font-thai-sb fs-18">Sort by : </span>
                  <Select
                    style={{ width: 150 }}
                    placeholder="Select"
                    defaultValue="WH_CODE"
                    onChange={this.onSort}
                  >
                    <Option value="wh_zone_loc_code">WH_CODE</Option>
                    <Option value="wh_zone_loc_name">WH_Name</Option>
                    <Option value="count_material">Material</Option>
                  </Select>

                  {this.state.sortasc === 1 ? (
                    <button
                      onClick={() => {
                        this.setState({ sortasc: 0 });
                        this.onSort(this.state.sorter);
                      }}
                      className="btn-success"
                      style={{
                        fontSize: 14,
                        marginLeft: 15,
                        padding: "0px 10px",
                      }}
                    >
                      ASC
                      <CaretDownOutlined style={{ fontSize: 35 }} />
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        this.setState({ sortasc: 1 });
                        this.onSort(this.state.sorter);
                      }}
                      className="btn-warning"
                      style={{
                        fontSize: 14,
                        marginLeft: 15,
                        padding: "0px 10px",
                      }}
                    >
                      DESC
                      <CaretUpOutlined style={{ fontSize: 35 }} />
                    </button>
                  )}
                </span>
              </div>

              <div className="row">
                {this.dataFiltered(
                  this.state.wh_index_selected,
                  this.state.wh_zone_index_selected
                ).map((item, index) => (
                  <div
                    className={
                      "col-3" +
                      (index + 1 >= this.state.wh_page * 8 - 7 &&
                      index + 1 <= this.state.wh_page * 8
                        ? ""
                        : " d-none")
                    }
                    key={item.wh_zone_loc_id}
                  >
                    <div className="card-warehouse">
                      <div className="image">
                        {item.is_main === true ? (
                          <div className="master">
                            <img src={Api.absoluteUrl("/icon/star.svg")} alt="" />
                          </div>
                        ) : null}

                        <img
                          src={Api.absoluteUrl("/img/warehouse.png")}
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <div className="detail">
                        <div className="dropdown">
                          <Dropdown
                            overlay={
                              <Menu>
                                <Menu.Item key="0">
                                  <a
                                    onClick={() =>
                                      this.onRenameFolder(index, item)
                                    }
                                  >
                                    <img
                                      src={Api.absoluteUrl("/icon/rename_dropdown.svg")}
                                      className="mr-2"
                                    />
                                    Edit
                                  </a>
                                </Menu.Item>
                                <Menu.Item key="1">
                                  <a className="c-red">
                                    <img
                                      src={Api.absoluteUrl("/icon/delete_dropdown.svg")}
                                      className="mr-2"
                                    />
                                    Delete
                                  </a>
                                </Menu.Item>
                              </Menu>
                            }
                            trigger={["click"]}
                          >
                            <a
                              className="ant-dropdown-link c-blue"
                              onClick={(e) => e.preventDefault()}
                            >
                              <svg
                                className="bi bi-three-dots"
                                width="1em"
                                height="1em"
                                viewBox="0 0 16 16"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </a>
                          </Dropdown>
                        </div>

                        <h5 className="font-thai-b fs-18 c-blue mb-0">
                          {item.wh_zone_loc_code}
                        </h5>
                        <span className="font-thai-b fs-18 c-blue">
                          {item.wh_zone_loc_name}
                        </span>
                        <div className="d-flex justify-content-between">
                          <span className="font-thai-b fs-18 c-black">
                            Total
                          </span>
                          <span className="font-thai-b fs-18 c-green">
                            {item.count_material}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <Pagination
                className="text-right"
                total={
                  this.dataFiltered(
                    this.state.wh_index_selected,
                    this.state.wh_zone_index_selected
                  ).length
                }
                onChange={(page) => this.setState({ wh_page: page })}
                showSizeChanger={false}
                size="small"
                current={this.state.wh_page}
                defaultPageSize={8}
                showTotal={() => {
                  return (
                    "Total " +
                    this.dataFiltered(
                      this.state.wh_index_selected,
                      this.state.wh_zone_index_selected
                    ).length +
                    " Warehouses"
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WareHouse;
